/* Match decorative section boundaries to their current visible neighbors. */
(() => {
  'use strict';
  const main = document.getElementById('MainContent');
  if (!main || main.dataset.feContinuityReady) return;
  main.dataset.feContinuityReady = 'true';
  const contentSelector = 'section[class^="ch-"], section[class*=" ch-"]';
  let pending = false;
  let previousWidth = window.innerWidth;

  function edgeColor(element, edge) {
    for (let node = element; node; node = node.parentElement) {
      const style = getComputedStyle(node);
      // The existing vertical technology gradient is white at its top edge.
      if (/^linear-gradient\((?:(?:180deg|to bottom),\s*)?rgba?\(/.test(style.backgroundImage)) {
        const colors = style.backgroundImage.match(/rgba?\([^)]*\)/g);
        if (colors?.length) return edge === 'end' ? colors[colors.length - 1] : colors[0];
      }
      const color = style.backgroundColor;
      if (color !== 'transparent' && color !== 'rgba(0, 0, 0, 0)') return color;
    }
    return 'rgb(255, 255, 255)';
  }

  function refresh() {
    pending = false;
    const entries = [];
    for (const wrapper of main.children) {
      if (!wrapper.classList.contains('shopify-section') || wrapper.getBoundingClientRect().height < 1) continue;
      const root = [...wrapper.children].find(node => node.matches(contentSelector)) ||
        [...wrapper.children].find(node => !['STYLE','SCRIPT','LINK'].includes(node.tagName) && node.getBoundingClientRect().height > 0);
      if (!root || getComputedStyle(root).display === 'none') continue;
      entries.push({root, start:edgeColor(root,'start'), end:edgeColor(root,'end')});
    }
    // Read all surfaces first, then write only CSS variables and decorative flags.
    for (const [i, entry] of entries.entries()) {
      const {root} = entry;
      if (!root.matches(contentSelector)) continue;
      root.style.setProperty('--fe-flow-start-bg', entry.start);
      root.toggleAttribute('data-fe-flow-after-night', !!entries[i-1]?.root.classList.contains('ch-night'));
      if (root.classList.contains('ch-night')) {
        root.style.setProperty('--fe-flow-prev-bg', entries[i-1]?.end || 'rgb(255, 255, 255)');
        root.style.setProperty('--fe-flow-next-bg', entries[i+1]?.start || 'rgb(255, 255, 255)');
      }
    }
  }
  function schedule() {
    if (!pending) { pending = true; requestAnimationFrame(refresh); }
  }
  refresh();
  window.addEventListener('load', schedule, {once:true});
  window.addEventListener('resize', () => {
    if (window.innerWidth !== previousWidth) { previousWidth = window.innerWidth; schedule(); }
  }, {passive:true});
  for (const event of ['shopify:section:load','shopify:section:unload','shopify:section:reorder']) document.addEventListener(event, schedule);
  // Theme editor replacement/reordering, without watching text, inputs, or our own attributes.
  new MutationObserver(schedule).observe(main, {childList:true});
})();
